module.exports = __webpack_public_path__ + "Roboto-Regular.95d71b853b33f23c802b.eot";


//////////////////
// WEBPACK FOOTER
// /Users/vladislavlazurenko/IdeaProjects/luiziana/frontend/src/roboto-fontface/fonts/roboto/Roboto-Regular.eot
// module id = ../../../../../src/roboto-fontface/fonts/roboto/Roboto-Regular.eot
// module chunks = styles